import { Card } from '@braze/web-sdk';
import { BrazeBottomSheetProps } from 'features/home/HomeScreen/components/BrazeBottomSheet/BrazeBottomSheet';
import { ProductOfferCardProps } from 'shared/components/vxl/cards/ProductOfferCard/ProductOfferCard';

export enum BrazeCardType {
  CLASSIC = 'classic',
  CAPTIONED_IMAGE = 'captionedImage',
  IMAGE_ONLY = 'imageOnly',
}

/**
 * Minimal SDK card interface for transform function parameters.
 * Both native ContentCard and web Card types satisfy this interface.
 */
export interface BrazeSdkCard {
  id: string;
  extras: Record<string, string | undefined>;
  dismissible: boolean;
  url?: string;
  pinned: boolean;
  expiresAt?: number | Date | null;
}

/**
 * Base interface for transformed Braze cards.
 */
export interface BrazeCardBase {
  id: string | undefined;
  url?: string;
  sdkCardWeb: Card | null;
}

/**
 * Transformed content card for app consumption.
 */
export interface BrazeContentCard extends BrazeCardBase {
  type: BrazeCardType;
  title: string | null;
  description: string | null;
  isDismissible: boolean;
  imageUrl: string | undefined;
  expiresAt: Date | undefined;
  pinned: boolean;
  ctaTitle?: string | undefined;
  cardBackground?: string | undefined;
}

type ProductOfferCardPropsWithoutOnPress = Omit<
  ProductOfferCardProps,
  'onPress'
>;

export interface BrazeSuccessProductOfferCard extends ProductOfferCardPropsWithoutOnPress {
  id: string | undefined;
  url?: string;
  sdkCardWeb: Card | null;
}

export type BrazeSuccessProductOfferCardIDs =
  | 'transfer_success_screen_offer'
  | 'get_advance_success_screen_offer'
  | 'repayment_success_screen_offer'
  | 'card_activation_success_screen_offer'
  | 'wallet_success_screen_offer'
  | 'money_in_the_bank_success_screen_offer'
  | 'dcf_success_screen_offer';

/**
 * Callback type for content card updates
 */
export type ContentCardsCallback = (
  cards: BrazeContentCard[],
  homeScreenBottomSheetContent: BrazeBottomSheetProps | null,
  productOfferCards: { [key: string]: BrazeSuccessProductOfferCard },
  marketingCarouselCards?: BrazeContentCard[],
) => void;
